<template>
    <v-main v-on:drop.prevent class="mx-xl-12 px-xl-12 mx-md-5 px-md-5 mx-sm-2 px-sm-2 my-0 py-0"
               style="height: 100%;">
        <v-layout row class="my-10">
            <v-flex md12 sm12>
                <div class="ml-6">
                    <div class="text-center text__colour-teal text__size-32 text__style-bold layout__margin__bottom-20">Select your print options</div>

                    <div>
                        <v-expansion-panels v-model="activeName" multiple class="">
                            <v-expansion-panel v-show="printWorkflow[0].show" :disabled="printWorkflow[0].disable">
                                <v-expansion-panel-header>Your paper type</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <el-radio-group v-model="printWorkflow[0].selected_value" v-on:change="next(printWorkflow[0])"
                                                    id="style" class="layout__position-left layout__padding-20px">
                                        <el-radio-button v-for="(paper_type) in printWorkflow[0].filter" :label="paper_type.option" :key="paper_type.option"
                                                        class="layout__position-left layout__border__all-1px-grey el-radio-button">

                                            <div class="el-radio-button-div">
                                                {{toTitleCase(paper_type.option)}}
                                            </div>

                                            <span v-show="paper_type.option === preferences.stockType" style="z-index: 1000"
                                                class="icon-tick text__colour-green component__promo text__size-24"></span>
                                        </el-radio-button>
                                    </el-radio-group>
                                </v-expansion-panel-content>
                            </v-expansion-panel>

                            <v-expansion-panel v-show="printWorkflow[1].show" :disabled="printWorkflow[1].disable">
                                <v-expansion-panel-header>Your paper weight</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <el-radio-group v-model="printWorkflow[1].selected_value" v-on:change="next(printWorkflow[1])"
                                                    id="weight" class="layout__position-left layout__padding-20px">
                                        <el-radio-button v-for="(paper_weight) in printWorkflow[1].filter" :label="paper_weight.option" :key="paper_weight.option"
                                                        class="layout__position-left layout__border__all-1px-grey el-radio-button">
                                            <div class="el-radio-button-div">
                                                {{paper_weight.option}}gsm
                                            </div>
                                            <span v-show="paper_weight.option == 350"
                                                class="icon-promote text__colour-red component__promo text__size-24">
                                            </span>
                                            <span v-show="paper_weight.option == 'LF23'" style="z-index: 1000"
                                                class="icon-promote text__colour-red component__promo text__size-24">
                                            </span>
                                            <span v-show="paper_weight.option === preferences.stockWeight" style="z-index: 1000"
                                                class="icon-tick text__colour-green component__promo text__size-24">
                                            </span>
                                        </el-radio-button>
                                    </el-radio-group>
                                </v-expansion-panel-content>
                            </v-expansion-panel>

                            <v-expansion-panel v-show="printWorkflow[2].show" :disabled="printWorkflow[2].disable">
                                <v-expansion-panel-header>Your lamination option</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <div v-for="(lamination) in printWorkflow[2].filter" :key="lamination.option"
                                         class="float-left">
                                        <el-radio-group v-model="printWorkflow[2].selected_value"
                                                        v-on:change="next(printWorkflow[2])"
                                                        class="layout__position-left">
                                            <el-radio-button :label="lamination.option"
                                                            :key="lamination.option"
                                                            class="layout__position-left layout__border__all-1px-grey el-radio-button">
                                                <div class="el-radio-button-div"
                                                    v-show="lamination.option == 'STANDARD' || lamination.option == '' || lamination.option === 'NONE' || lamination.option === 'SILK'">
                                                    None
                                                </div>
                                                <div class="el-radio-button-div"
                                                    v-show="lamination.option == 'GLOSS LAM' || lamination.option == 'GLOSS'">
                                                    Gloss
                                                </div>
                                                <div class="el-radio-button-div"
                                                    v-show="lamination.option == 'MATT LAM' || lamination.option == 'MATT'">
                                                    Matt
                                                </div>
                                                <span v-show="lamination.option === preferences.lamination" style="z-index: 1000"
                                                    class="icon-tick text__colour-green component__promo text__size-24">
                                                </span>
                                            </el-radio-button>
                                        </el-radio-group>
                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>

                            <v-expansion-panel>
                                <v-expansion-panel-header class="layout__padding__bottom-5px text__line-height-2 text__size-16">Directmailr template<br>Price includes data, print and second class postage</v-expansion-panel-header>
                                <v-expansion-panel-content>

                                    <div class="text__size-16" v-show="this.price.order_total !== 'Contact Customer Services for a price on 0191 917 9331'">
                                        <div class="layout__display-table">
                                            <span class="layout__float-right">
                                                {{printWorkflow[3].selected_value}}x records (£{{this.price.price_per_item}} each): £{{this.price.net_order_total}}
                                            </span>
                                            <br>
                                            <span class="layout__float-right">
                                                VAT: £{{this.price.vat_total_price}}
                                            </span>
                                            <br>
                                            <span class="layout__float-right text__colour-teal text__style-bold">
                                                Total: £{{this.price.order_grand_total}}
                                            </span>
                                        </div>
                                    </div>

                                    <div class="text__size-16" v-show="this.price.order_total === 'Contact Customer Services for a price on 0191 917 9331'">
                                        <span class="component__price-span">
                                            Contact Customer Services for a price on 0191 917 9331
                                        </span>
                                    </div>

                                </v-expansion-panel-content>
                            </v-expansion-panel>
                         </v-expansion-panels>
                    </div>

                    <v-layout row class="layout__margin__top-50">
                        <v-flex md6 class="text-left">
                            <el-button class="button__base layout__width-200px button-teal layout__cursor-pointer layout__float-left"
                                    v-on:click="navigate('preview-design')">Back
                            </el-button>
                        </v-flex>

                        <v-flex md6 class="text-right">
                            <el-button class="button__base layout__width-200px button-teal layout__cursor-pointer" :disabled="savePreferencesText === 'Saved'"
                                    v-on:click="savePreferences()">{{savePreferencesText}}
                            </el-button>
                            <el-button  class="button__base layout__width-200px button__background-red layout__cursor-pointer" :disabled="isOrderReady"
                                    v-on:click="navigate('checkout')">Confirm
                            </el-button>
                        </v-flex>
                    </v-layout>

                    <v-overlay :value="loading || dataOrderLoading">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>

                </div>
            </v-flex>

        </v-layout>
    </v-main>
</template>

<script>
    import Router from '../../router.js';
    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';

    export default {
        name: "InstantMarketingPrintOptions",
        components: {
        },
        computed: {
            isOrderReady() {
                return (this.price.priceCode === '')
                    || this.loading
                    || this.dataOrderLoading
                    || !this.order.branchId
                    || !(this.order.printJobSpec && this.order.printJobSpec.stockType)
                    || !(this.order.printJobSpec && this.order.printJobSpec.fCode)
                    || !(this.order.printJobSpec && this.order.printJobSpec.stockWeight);
            },
        },
        mixins: [axios],
        data() {
            return {
                data: [],
                order: {},
                quantity: 0,
                activeName: [],
                subActive: [],
                loading: false,
                dataOrderLoading: false,
                product: {},
                config: {},
                preferences: {},
                savePreferencesText: 'Save my preferences',
                predefinedSelections: {
                    subCategory: '',
                    finishedSizeFilter: '',
                    finishedOrientationFilter: '',
                    foldTypeFilter: '',
                    creasingFilter: '',
                    pageCountFilter: '',
                    stockTypeFilter: '',
                    stockWeightFilter: '',
                    laminationFilter: '',
                    quantityFilter: ''
                },
                printWorkflow: [
                    {
                        value: 0,
                        name: 'type',
                        disable: true,
                        show: true,
                        parameter_name: 'stockTypeFilter',
                        property: 'stockType',
                        selected_value: '',
                        filter: []
                    },
                    {
                        value: 1,
                        name: 'weight',
                        disable: true,
                        show: true,
                        parameter_name: 'stockWeightFilter',
                        property: 'stockWeight',
                        selected_value: '',
                        filter: []
                    },
                    {
                        value: 2,
                        name: 'lamination',
                        disable: true,
                        show: true,
                        parameter_name: 'laminationFilter',
                        property: 'lamination',
                        selected_value: '',
                        filter: []
                    },
                    {
                        value: 3,
                        name: 'qty',
                        disable: true,
                        show: true,
                        parameter_name: 'quantityFilter',
                        property: 'quantity',
                        selected_value: '0',
                        filter: [],
                    }
                ],
                template: {},
                product: '',
                price: {
                    minimumQty: 0,
                    productRef: '',
                    priceCode: '',
                    list_price: 0.00,
                    price_per_item: 0.00,
                    net_order_total: 0.00,
                    vat_total_price: 0.00,
                    order_total: 0.00,
                    order_grand_total: 0.00
                },
                priceCodes: null,
                rules: {
                    selected_value: [{
                        message: '',
                        trigger: 'blur'
                    }],
                }

            }
        },
        mounted() {
            this.loading = true;

            this.preferences = JSON.parse(window.sessionStorage.getItem('_imPreference'))

            if (this.preferences.lamination !== undefined) {
                this.preferences.lamination = this.preferences.lamination.replace(' LAM', '');
            }

            const getOrderById = `${process.env.VUE_APP_TKGATEWAY}/api/DataOrder/` + window.sessionStorage.getItem('_order_id');

            Axios.get(getOrderById, this.returnHeaderUsingToken())
                .then(response => {
                    console.log(response.data);

                    this.order = response.data[0];

                    // Populate radio buttons with existing printJobSpec/preferences values (if any)
                    if (this.order.printJobSpec.stockType !== null) {
                        this.printWorkflow[0].selected_value = this.order.printJobSpec.stockType;
                    } else {
                        if (this.preferences.stockType !== undefined) {
                            this.printWorkflow[0].selected_value = this.preferences.stockType;
                        }
                    }

                    if (this.order.printJobSpec.stockWeight !== null) {
                        this.printWorkflow[1].selected_value = this.order.printJobSpec.stockWeight;
                    } else {
                        if (this.preferences.stockWeight !== undefined) {
                            this.printWorkflow[1].selected_value = this.preferences.stockWeight;
                        }
                    }

                    if (this.order.printJobSpec.lamination !== null) {
                        this.printWorkflow[2].selected_value = this.order.printJobSpec.lamination.replace(' LAM', '');
                    } else {
                        if (this.preferences.lamination !== undefined) {
                            this.printWorkflow[2].selected_value = this.preferences.lamination;
                        }
                    }

                    console.log('this.printWorkflow[0].selected_value=' + this.printWorkflow[0].selected_value);
                    console.log('this.printWorkflow[1].selected_value=' + this.printWorkflow[1].selected_value);
                    console.log('this.printWorkflow[2].selected_value=' + this.printWorkflow[2].selected_value);
                    console.log('this.price.order_grand_total=' + this.price.order_grand_total);

                    for (let i = 0; i < this.printWorkflow.length; i++) {
                        this.printWorkflow[i].show = true
                    }

                    this.quantity = this.order.printJobSpec.quantity;
                    this.template = JSON.parse(window.sessionStorage.getItem('_template'));
                    this.printWorkflow[3].selected_value = this.quantity;
                    this.prefillAllSelections();

                    this.loading = false;
                    parent.postMessage('ScrollIntoView', '*');
                });
        },
        beforeUpdate() {

            // todo smash into session storage
        },
        methods: {
            navigate(path) {
                Router.push({
                    path: '/' + path
                });
            },
            next(workflow) {
                this.loading = true;

                this.setPriceCode();
                this.saveQuantity();
                this.saveDataOrder();

                this.loading = false;
            },
            prefillAllSelections() {
                console.log('prefillAllSelections');
                console.log('this.order.printJobSpec.fCode=' + this.order.printJobSpec.fCode);

                this.loading = true;

                this.priceCodes = window.sessionStorage.getItem('_priceCodes');

                console.log('this.priceCodes=' + this.priceCodes);

                if (this.priceCodes !== null) {
                    var priceCodeArray = this.priceCodes.split(',');

                    for(var i = 0; i < priceCodeArray.length; i++)
                    {
                        console.log(priceCodeArray[i]);

                        var priceCodePartArray = priceCodeArray[i].split('_');

                        if (['F001', 'F002', 'F409'].includes(priceCodePartArray[0])) {
                            this.pushIfNotExists(0, 'UNCOATED');
                        }

                        if (['F014', 'F020'].includes(priceCodePartArray[0])) {
                            this.pushIfNotExists(0, 'SILK');
                        }

                        var stockWeight = parseInt(priceCodePartArray[1]),
                            lamination = priceCodePartArray[1].replace(stockWeight, '');

                        console.log('stockWeight=' + stockWeight);
                        console.log('lamination=' + lamination);

                        this.pushIfNotExists(1,  stockWeight.toString());

                        if (lamination == 'ML') {
                            this.pushIfNotExists(2, 'MATT');
                        }

                        this.pushIfNotExists(2, 'NONE');
                    }
                }

                console.log('this.printWorkflow[0]=' + JSON.stringify(this.printWorkflow[0]));
                console.log('this.printWorkflow[1]=' + JSON.stringify(this.printWorkflow[1]));
                console.log('this.printWorkflow[2]=' + JSON.stringify(this.printWorkflow[2]));

                this.activeName.push(0);
                this.printWorkflow[0].disable = false;
                this.activeName.push(1);
                this.printWorkflow[1].disable = false;
                this.activeName.push(2);
                this.printWorkflow[2].disable = false;
                this.activeName.push(3);

                // If only 1 option returned for a workflow then select it by default
                if (this.printWorkflow[0].filter.length == 1) {
                    this.printWorkflow[0].selected_value = this.printWorkflow[0].filter[0].option;
                }

                if (this.printWorkflow[1].filter.length == 1) {
                    this.printWorkflow[1].selected_value = this.printWorkflow[1].filter[0].option;
                }

                if (this.printWorkflow[2].filter.length == 1) {
                    this.printWorkflow[2].selected_value = this.printWorkflow[2].filter[0].option;
                }

                console.log('this.activeName' + JSON.stringify(this.activeName));

                this.setPriceCode();
                this.saveQuantity();
                this.saveDataOrder();

                this.loading = false;
            },
            clearFilters(indexFilter) {
                console.log('clearing filters ', indexFilter)
                for (indexFilter; indexFilter < this.printWorkflow.length; indexFilter++) {

                    if (indexFilter !== 3) {
                        console.log('!== 3')

                        this.printWorkflow[indexFilter].filter = []
                        this.printWorkflow[indexFilter].selected_value = ''
                    }

                    if (this.printWorkflow[indexFilter].name !== 'qty') {
                        this.price.vat_total_price = 0.00;
                        this.price.order_total = 0.00;
                        this.price.net_order_total = 0.00;
                        this.price.priceCode = '';
                        this.price.minimumQty = 0;
                    }
                }
            },
            pushIfNotExists(workflow, value) {
                var optionExists = false;

                for (var option, i = 0; option = this.printWorkflow[workflow].filter[i++];) {
                    if (option.option == value) {
                        optionExists = true;
                        break;
                    }
                }

                if (!optionExists) {
                    this.printWorkflow[workflow].filter.push({
                        'option': value
                    })
                }
            },
            setPriceCode() {
                console.log('setPriceCode');

                if (this.printWorkflow[0].selected_value !== '' && this.printWorkflow[1].selected_value !== '' && this.printWorkflow[2].selected_value !== '') {
                    var product_code = this.order.printJobSpec.fCode + '_' + this.printWorkflow[1].selected_value;
                    if (this.printWorkflow[2].selected_value == 'MATT') {
                        product_code += 'ML';
                    }
                    product_code += '_DM';

                    this.price.priceCode = product_code;
                }

                console.log('this.price.priceCode=' + this.price.priceCode);
            },
            saveQuantity() {
                console.log('saveQuantity');

                this.loading = true;

                let skuFinder = `${process.env.VUE_APP_TKGATEWAY}/api/services/app/Catalogues/GetPrintProductDetails/?catalogueRef=${process.env.VUE_APP_CATALOGUE_REF}&orderSource=PDFUPLOAD&priceCode=` + this.price.priceCode + '&quantity=' + this.printWorkflow[3].selected_value;

                console.log(skuFinder)

                Axios.get(skuFinder)
                    .then(response => {
                        console.log(response.data.result.pricingResult);

                        if (response.data.result.pricingResult !== undefined) {
                            if (response.data.result.pricingResult.billNetTotalBeforeDiscount !== 0) {
                                let vat_rate = response.data.result.pricingResult.billVatRate / 100;
                                console.log('vat_rate=' + vat_rate);

                                this.price.productRef = response.data.result.pricingResult.productRef;
                                this.price.list_price = parseFloat(response.data.result.pricingResult.itemListPrice).toFixed(3);

                                console.log('this.price.productRef=' + this.price.productRef);
                                console.log('this.price.list_price=' + this.price.list_price);
                            } else {
                                this.price.order_total = 'Contact Customer Services for a price on 0191 917 9331';
                            }
                        }

                        this.loading = false;
                    })
                    .catch(error => {
                        console.log(error)

                        this.loading = false;
                    })
            },
            saveDataOrder() {
                console.log('saveDataOrder');

                this.dataOrderLoading = true;

                let getPrintDetails = `${process.env.VUE_APP_TKGATEWAY}/api/services/app/Catalogues/GetPrintProductDetails/?catalogueRef=${process.env.VUE_APP_CATALOGUE_REF}&orderSource=PDFUPLOAD&priceCode=` + this.price.priceCode + '&quantity=' + this.order.printJobSpec.quantity;
                console.log(getPrintDetails)
                Axios.get(getPrintDetails, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log('getting the print spec for each saved price code');
                        console.log(response.data.result);

                        const patch_order = `${process.env.VUE_APP_TKGATEWAY}/api/DataOrder/` + this.order.id;
                        const update_body = [
                            {
                                "value": this.template.pageCount,
                                "path": "/printJobSpec/pageCount",
                                "op": "replace"
                            },
                            {
                                "value": this.template.pageHeight,
                                "path": "/printJobSpec/pageHeight",
                                "op": "replace"
                            },
                            {
                                "value": this.template.pageWidth,
                                "path": "/printJobSpec/pageWidth",
                                "op": "replace"
                            },
                            {
                                "value": this.template.pageWidth,
                                "path": "/printJobSpec/actualPageWidth",
                                "op": "replace"
                            },
                            {
                                "value": this.template.pageHeight,
                                "path": "/printJobSpec/actualPageHeight",
                                "op": "replace"
                            },
                            {
                                "value": this.template.orientation,
                                "path": "/printJobSpec/pageOrientation",
                                "op": "replace"
                            },
                            {
                                "value": this.price.net_order_total,
                                "path": "/netTotalPrice",
                                "op": "replace"
                            },
                            {
                                "value": this.price.vat_total_price,
                                "path": "/vatTotalPrice",
                                "op": "replace"
                            },
                            {
                                "value": this.price.list_price,
                                "path": "/netUnitPrice",
                                "op": "replace"
                            }
                        ];

                        if (response.data.result.printJobSpec !== undefined) {
                            update_body.push({
                                "value": response.data.result.printJobSpec.fCode,
                                "path": "/printJobSpec/fCode",
                                "op": "replace"
                            },
                            {
                                "value": response.data.result.printJobSpec.stockType,
                                "path": "/printJobSpec/stockType",
                                "op": "replace"
                            },
                            {
                                "value": response.data.result.printJobSpec.stockWeight,
                                "path": "/printJobSpec/stockWeight",
                                "op": "replace"
                            },
                            {
                                "value": response.data.result.printJobSpec.lamination,
                                "path": "/printJobSpec/lamination",
                                "op": "replace"
                            });
                        }

                        if (this.price.productRef !== undefined) {
                            update_body.push({
                                "value": this.price.productRef,
                                "path": "/productPriceCode",
                                "op": "replace"
                            });
                        }

                        if (this.price.order_total == 'Please contact our Customer Service team for a price on 0191 917 9331') {
                            update_body.push({
                                "value": 0.00,
                                "path": "/grossTotalPrice",
                                "op": "replace"
                            });
                        } else {
                            update_body.push({
                                "value": this.price.order_total,
                                "path": "/grossTotalPrice",
                                "op": "replace"
                            });
                        }

                        console.log(patch_order);
                        console.log(update_body);

                        Axios.patch(patch_order, update_body, this.returnHeaderUsingToken())
                            .then(response => {
                                console.log(response.data);
                                console.log('quantity=' + response.data.printJobSpec.quantity);
                                console.log('netTotalPrice=' + response.data.netTotalPrice);
                                console.log('vatTotalPrice=' + response.data.vatTotalPrice);
                                console.log('grossTotalPrice=' + response.data.grossTotalPrice);
                                console.log('this.price.priceCode=' + this.price.priceCode);

                                // save the newest data
                                this.order = response.data;

                                // if (this.price.priceCode !== '') {
                                if (this.priceCodes !== null) {
                                    this.price.price_per_item = parseFloat(response.data.netTotalPrice / response.data.printJobSpec.quantity).toFixed(2);
                                    this.price.net_order_total = parseFloat(response.data.netTotalPrice).toFixed(2);
                                    this.price.vat_total_price = parseFloat(response.data.vatTotalPrice).toFixed(2);
                                    this.price.order_grand_total = parseFloat(response.data.grossTotalPrice).toFixed(2);
                                }

                                this.dataOrderLoading = false;
                            })
                            .catch(error => {
                                console.log(error)

                                this.dataOrderLoading = false;
                            });
                    });
            },
            savePreferences() {
                this.loading = true;

                var customer = JSON.parse(window.sessionStorage.getItem('customer'));
                let customerRef = customer.ref;

                console.log(customerRef);
                console.log('this.price.priceCode=' + this.price.priceCode);
                
                let skuFinder = `${process.env.VUE_APP_TKGATEWAY}/api/services/app/Catalogues/SaveCatalogueBookmark/?catalogueRef=${process.env.VUE_APP_CATALOGUE_REF}&orderSource=PDFUPLOAD&customerRef=` + customerRef + '&priceCode=' + this.price.priceCode + '&quantity=' + this.order.printJobSpec.quantity;

                console.log(skuFinder);

                console.log(this.returnHeaderUsingToken());

                Axios.put(skuFinder, {}, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response);

                        //let customerRef = JSON.parse(this.returnCookie('_customer')).ref;
                        var customer = JSON.parse(window.sessionStorage.getItem('customer'));
                        let customerRef = customer.ref;

                        console.log(customerRef);

                        this.getUserPreferences(customerRef);

                        this.savePreferencesText = 'Saved';
                        this.loading = false;
                    })
                    .catch(error => {
                        console.log(error);

                        this.loading = false;
                    })
            },
            toTitleCase(str) {
                return str.replace(
                    /\w\S*/g,
                    function(txt) {
                        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                    }
                );
            }
        }
    };
</script>
